import { render, staticRenderFns } from "./EditSeller.vue?vue&type=template&id=f0208a54&scoped=true&"
import script from "./EditSeller.vue?vue&type=script&lang=js&"
export * from "./EditSeller.vue?vue&type=script&lang=js&"
import style0 from "./EditSeller.vue?vue&type=style&index=0&id=f0208a54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0208a54",
  null
  
)

export default component.exports